export default __webpack_public_path__ + "static/media/movings.1f820f4d.jpg";